import { makeStyles, Theme } from "@material-ui/core/styles";
import { error } from "../../../../../../../infrastructure/theme/customColors";

const useStyles = makeStyles<Theme>((theme) => ({
  title: {
    fontSize: "14px",
  },
  container: {
    marginTop: "30px",
  },
  containerSlider: {
    width: "276px",
    height: "55px",
  },
  amountContainerLeft: {
    marginRight: "30px",
  },
  amountContainerRight: {
    marginLeft: "30px",
  },
  amountNameContainer: {
    height: "55px",
    width: "135px",
    backgroundColor: "#E0E0E0",
  },
  name: {
    fontSize: "12px",
    fontWeight: 700,
  },
  amountText: {
    fontSize: "10px",
    fontStyle: "italic",
    margin: "4px 0px",
  },
  amountStyle: {
    fontSize: "16px",
    fontWeight: 700,
    marginLeft: theme.spacing(1),
  },
  buttonContainer: {
    marginTop: theme.spacing(4),
  },
  errorMessage: {
    fontSize: "10px",
    color: error,
  },
}));

export default useStyles;
